import { axios } from "@Root/API";

export const postNewPassword = (reset_token, new_password) => {
  return axios.post("password/set-new", { reset_token, new_password });
};
